import classNames from 'classnames'
import {ComponentProps} from 'react'
import S from './styles.module.scss'
import {UniversalLink} from '../UniversalLink'

export interface LinkProps extends ComponentProps<typeof UniversalLink> {
  variant?:
    | 'breadcrumb'
    | 'default'
    | 'nav'
    | 'sidebar'
    | 'sidebar-current'
    | 'stealth'
    | 'ui'
    | 'unstyled'
  disabled?: boolean
}

export const Link = ({
  variant = 'default',
  disabled = false,
  ...props
}: LinkProps) => {
  return (
    <UniversalLink
      {...props}
      className={classNames(
        S[variant],
        disabled && S.disabled,
        props.className,
      )}
    />
  )
}
